<template>
    <div class="malt-environnement-marker">
        <ClientOnly>
            <Marker v-if="isDevIntegration" :color="theme.color.brand.primary[70]" icon="code">
                Dev Integration
                <template #description>You are working in development with integration data.</template>
            </Marker>
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useHead, useMaltEnvironnement} from '#imports';
    import theme from '@maltjoy/themes';
    import Marker from './Marker.common.vue';

    const maltEnvironnement = useMaltEnvironnement();

    const isDevIntegration = computed(() => import.meta.dev && maltEnvironnement === 'DEV_INTEGRATION');

    if (isDevIntegration.value) {
        useHead({
            link: [
                {
                    rel: 'icon',
                    sizes: '32x32',
                    href: '//dam.malt.com/favicon-dev-integration.png?vh=04f041',
                },
            ],
        });
    }
</script>
